import { render, staticRenderFns } from "./cModalProductList.vue?vue&type=template&id=8c13f360&scoped=true"
import script from "./cModalProductList.vue?vue&type=script&lang=js"
export * from "./cModalProductList.vue?vue&type=script&lang=js"
import style0 from "./cModalProductList.vue?vue&type=style&index=0&id=8c13f360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c13f360",
  null
  
)

export default component.exports